import * as React from 'react'
import Box from '@mui/material/Box'
import RawTable from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import Paper from '@mui/material/Paper'
import TableHeader from './TableHeader'
import TableHead from './TableHead'
import useTable from 'logic/useTable'
import TableBody from './TableBody'
import TablePagination from './TablePagination'
import {styled} from 'common'
import DialogForm from '../Dialogs/DialogForm'
import useDialogForm from 'logic/useDialogForm'

const Table = ({
    useGetQuery,
    paginationType,
    useDeleteMutation,
    useCreateMutation,
    itemName,
    visibleKeys,
    allowDelete,
    allowEdit,
    allowCreate,
    allowExpanded,
    useEditMutation,
    tooltipErrorMessage,
    tableActions,
    costumeTableHeaderActions,
    useModal = () => ({}),
    useGetByIdQuery = () => ({}),
    useFormLogic,
    tableHeight = 100,
}) => {
    const {
        tableName,
        tableKeys,
        tableData,
        keyTypes,
        keyTranslate,
        externalKeys,
        tableItems,
        totalItems,
        errorMessage,
        filters,
        isLoadingTableData,
        isLoadingItem,
        doDelete,
    } = useTable(
        itemName,
        useGetQuery,
        paginationType,
        useDeleteMutation,
        visibleKeys,
        allowExpanded,
        useModal
    )

    const {
        fieldsFormDialog,
        handleOnClickRow,
        handleDialog,
        isLoadingDialog,
        itemId,
        openDialog,
        setOpenDialog,
        validationSchema,
    } = useDialogForm({useModal})

    return (
        <Box sx={{width: '100%'}}>
            <ErrorMessage>{errorMessage}</ErrorMessage>
            <Paper sx={{width: '100%', overflow: 'hidden'}} elevation={6}>
                <TableHeader
                    tableName={tableName}
                    numSelected={0}
                    filters={filters}
                    setOpenAddDialog={handleDialog}
                    tooltipErrorMessage={tooltipErrorMessage}
                    allowCreate={allowCreate}
                    isLoading={isLoadingTableData}
                    costumeActions={costumeTableHeaderActions}
                />
                <TableContainer sx={{height: `calc(${tableHeight}dvh - 209px)`}}>
                    <RawTable
                        sx={{minWidth: 750}}
                        stickyHeader
                        aria-label="tableTitle"
                        size="small">
                        <TableHead
                            tableKeys={tableKeys}
                            itemName={itemName}
                            allowDelete={allowDelete}
                            allowEdit={allowEdit}
                            allowExpanded={allowExpanded}
                        />
                        <TableBody
                            itemName={itemName}
                            tableName={tableName}
                            tableKeys={tableKeys}
                            keyTypes={keyTypes}
                            externalKeys={externalKeys}
                            keyTranslate={keyTranslate}
                            tableItems={tableItems}
                            tableData={tableData}
                            rowClickAction={handleOnClickRow}
                            allowDelete={allowDelete}
                            allowEdit={allowEdit}
                            allowExpanded={allowExpanded}
                            onClickDelete={doDelete}
                            onClickEdit={handleDialog}
                            tableActions={tableActions}
                        />
                    </RawTable>
                </TableContainer>
                <TablePagination
                    itemName={itemName}
                    paginationType={paginationType}
                    totalItems={totalItems}
                />
            </Paper>

            {openDialog && (
                <DialogForm
                    key={`dialog_key_${itemId}`}
                    itemId={itemId}
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                    fields={fieldsFormDialog}
                    useGetByIdQuery={useGetByIdQuery}
                    i18nCategory={tableName}
                    itemName={itemName}
                    isLoading={isLoadingDialog || isLoadingItem}
                    useCreateMutation={useCreateMutation}
                    useEditMutation={useEditMutation}
                    setOpenDialog={setOpenDialog}
                    useFormLogic={useFormLogic}
                    validationSchema={validationSchema}
                />
            )}
        </Box>
    )
}

export default Table

const ErrorMessage = styled.span``
